import React from 'react';
import styled from 'styled-components';
import withPageEntry from '../../withPageEntry';
import * as AppActions from '../../AppActions';
import * as JStorage from '../../JStorage';
import {useOutlet} from 'reconnect.js';
import qs from 'query-string';
import Theme from '../../Theme';
import * as Ant from 'antd';
import Breadcrumb from '../../Components/Breadcrumb';

const orgs = {
  council: '理事會組織表',
  supervisory_board: '監事會',
  extra: '其他',
};

function AboutOrgChart(props) {
  const [about] = useOutlet('about');

  return (
    <Wrapper>
      <div className="tda-header">
        <h2>第22屆理監事組織表</h2>
        <Breadcrumb third="第22屆理監事組織表" />
      </div>

      {about?.org_chart &&
        Object.keys(orgs).map((key) => (
          <div>
            <h3>{orgs[key]}</h3>
            {(about.org_chart[key] || []).map((position) => (
              <div key={position.name} className="position">
                <div className="title">{position.name}</div>
                <div className="members">
                  {(position.members || []).map((member) => (
                    <div key={member.username} className="member">
                      <img src={member.avatar} alt="member-avatar" />
                      <div>{member.username}</div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        ))}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  & h3 {
    border-left: solid 3px var(--primaryColor);
    color: var(--primaryColor);
    padding-left: 20px;
    margin-bottom: 20px;
    font-size: 20px;
  }

  & .position {
    display: flex;

    & > .title {
      font-size: 18px;
      font-weight: 500px;
      margin-right: 20px;
      color: var(--primaryColor);
      flex-basis: 110px;
    }
    & > .members {
      padding-bottom: 10px;
      border-bottom: solid 1px rgba(0, 0, 0, 0.1);
      margin-bottom: 20px;
      flex: 1;
      display: flex;
    }
  }

  & .member {
    text-align: center;
    margin-right: 30px;
    font-size: 16px;
    font-weight: bold;

    & > img {
      width: 100px;
    }
  }
`;

export default withPageEntry(AboutOrgChart);
